export const handleClick = (event, isMobile, url) => {
	const { id } = event.target;

	if (id !== 'links-share-FACEBOOK' && id !== 'links-share-TWITTER') {
		event.preventDefault();
	}

	if (id === 'links-share-FACEBOOK' || id === 'links-share-TWITTER') {
		window.open(url, 'popup', 'width=600, height=450');
	}

	if (id === 'links-share-COPY') {
		document.querySelector('#links-share-clipboard').select();
		document.execCommand('copy');
	}

	if (!isMobile && id === 'links-share-PRINT') {
		const afterPrint = () => {
			const uiWidgetOverlay =
				document.querySelector('.ui-widget-overlay');

			if (uiWidgetOverlay) {
				uiWidgetOverlay.classList.remove('d-print-none');
			}
		};

		// remove sidebar positioning classes pre-print
		const beforePrint = () => {
			let currentTarget = document.getElementById(id);
			const uiWidgetOverlay =
				document.querySelector('.ui-widget-overlay');

			if (uiWidgetOverlay) {
				uiWidgetOverlay.classList.add('d-print-none');

				// Traversing the DOM to find closest ui-dialog class and hide it on print.
				for (
					;
					currentTarget;
					currentTarget = currentTarget.parentNode
				) {
					if (currentTarget.matches('.ui-dialog')) {
						currentTarget.classList.add('d-print-none');

						break;
					}
				}
			}
		};

		// Polyfill for Safari not implementing the onafterprint or onbeforeprint events
		if (
			window.matchMedia &&
			(typeof window.onafterprint === 'undefined' ||
				typeof window.onbeforeprint === 'undefined')
		) {
			const mediaQueryList = window.matchMedia('print');

			mediaQueryList.addListener((mql) => {
				if (mql.matches) {
					beforePrint();
				} else {
					afterPrint();
				}
			});
		}

		window.onafterprint = afterPrint;
		window.onbeforeprint = beforePrint;

		window.print();
	}
};
